import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  itemName = 'item',
  titleName
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
          width: 420,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              bgcolor: '#FEF3C7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
              boxShadow: '0 0 0 10px #FFFBEB',
            }}
          >
            <WarningAmberRoundedIcon
              sx={{
                color: '#D97706',
                fontSize: 30,
              }}
            />
          </Box>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: '#111827',
            }}
          >
            Delete {titleName || itemName}?
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 0 }}>
        <Typography
          align="center"
          sx={{
            color: '#6B7280',
            fontSize: 14,
            lineHeight: 1.7,
          }}
        >
          Are you sure you want to delete this{' '}
          <strong>{itemName}</strong>?
          <br />
          This action cannot be undone.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          gap: 1.5,
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            minWidth: 110,
            textTransform: 'none',
            fontWeight: 600,
            color: '#475569',
            borderColor: '#CBD5E1',
            '&:hover': {
              borderColor: '#94A3B8',
              backgroundColor: '#F8FAFC',
            },
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{
            minWidth: 110,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;